import React, { useEffect } from 'react'
import '../../styles/CarrerOne.css'
import { Professor} from '../../assets/index'

const CareerOne = () => {
  useEffect(() => {
    const revealElements = document.querySelectorAll(".career-scroll-reveal");

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("career-is-visible"); 
        } else {
          entry.target.classList.remove("career-is-visible"); 
        }
      });
    }, { threshold: 0.8 });

    revealElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      revealElements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);

  const cardContent = [
    { icon: "/assets/Career_Icons/investment.svg", front: "Investment Banking", back: "Explore opportunities in Investment Banking." },
    { icon: "/assets/Career_Icons/analyst.svg", front: "Financial Analyst", back: "Learn to analyze financial data for strategic decisions." },
    { icon: "/assets/Career_Icons/budget.svg", front: "Budget Analyst", back: "Manage and optimize budgets effectively for businesses." },
    { icon: "/assets/Career_Icons/fpa.svg", front: "FP&A", back: "Plan and analyze financial outcomes for organizational success." },
    { icon: "/assets/Career_Icons/asset.svg", front: "Asset Management", back: "Grow and manage wealth portfolios for clients." },
    { icon: "/assets/Career_Icons/consulting.svg", front: "Business Consulting", back: "Provide insights and solutions for business excellence." },
  ];

  return (
    <>
      <div className="career-container ">
        <div className="career-line career-scroll-reveal"></div>
        <h2 className="career-heading career-scroll-reveal" style={{ fontWeight: '700' }}>Careers</h2>
        <div className="career-main">
          <div className="career-cards relative right-[5rem]">
            {cardContent.map((content, index) => (
              <div className="career-card-container" key={index}>
                <div className="career-card">
                  <div className="career-front">
                    <img src={content.icon} alt={content.front} className="career-icon" />
                    <p className="career-front-heading">{content.front}</p>
                  </div>
                  <div className="career-back">
                    <p className="career-back-heading">{content.back}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="career-image-container career-scroll-reveal">
            <img
              src={Professor}
              alt="Professional"
              className="career-image hidden sm:block"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerOne;